import useWidgetQuery from '../../../hooks/useWidgetQuery.js';
const useSearchResultsQuery = () => useWidgetQuery();
export default useSearchResultsQuery;
